"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberSource = void 0;
const core_1 = require("flow-connect/core");
const ui_1 = require("flow-connect/ui");
class NumberSource extends core_1.Node {
    constructor() {
        super();
    }
    setupIO() {
        this.addTerminals([{ type: core_1.TerminalType.OUT, name: "value", dataType: "number" }]);
    }
    created(options) {
        const { width = 160, name = "Number Source", state = {}, style = {} } = options;
        this.width = width;
        this.name = name;
        this.state = Object.assign(Object.assign({}, NumberSource.DefaultState), state);
        this.style = Object.assign({ rowHeight: 10 }, style);
        this.setupUI();
        this.setupListeners();
    }
    process() {
        this.input.style.step = this.state.fractional ? "any" : "";
        this.setOutputs(0, this.state.fractional ? this.state.value : Math.floor(this.state.value));
    }
    setupUI() {
        this.fractionalToggle = this.createUI("core/toggle", {
            propName: "fractional",
            input: true,
            output: true,
            height: 10,
            style: { grow: 0.2 },
        });
        this.input = this.createUI("core/input", {
            value: 0,
            propName: "value",
            input: true,
            output: true,
            height: 20,
            style: { type: ui_1.InputType.Number, grow: 0.6, step: this.state.fractional ? "any" : "" },
        });
        this.ui.append([
            this.createUI("core/x-layout", {
                childs: [this.createUI("core/label", { text: "Value", style: { grow: 0.4 } }), this.input],
                style: { spacing: 20 },
            }),
            this.createUI("core/x-layout", {
                childs: [this.createUI("core/label", { text: "Fractional ?", style: { grow: 0.5 } }), this.fractionalToggle],
                style: { spacing: 20 },
            }),
        ]);
    }
    setupListeners() {
        this.watch("fractional", () => this.process());
        this.watch("value", () => this.process());
        this.outputs[0].on("connect", () => this.process());
        this.on("process", () => this.process());
    }
}
exports.NumberSource = NumberSource;
NumberSource.DefaultState = { fractional: false, value: 0 };
